import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Card } from "react-bootstrap";
import "./LegalPages.css";

const siteName = "Shivay Tour & Travells";
const siteUrl = "https://www.shivaytourandtravells.com";
const contactEmail = "shivaytourandtravells@gmail.com";
const contactPhone = "+91-7600668600";
const effectiveDate = "October 6, 2025";

export default function PrivacyPolicy() {
    return (
        <Container className="legal-page my-5">
            <Helmet>
                <title>Privacy Policy | {siteName}</title>
                <meta
                    name="description"
                    content={`${siteName} Privacy Policy — Learn how we collect, use, and protect your personal data.`}
                />
            </Helmet>

            <div className="text-center mb-5">
                <h1 className="legal-heading">Privacy Policy</h1>
                <p className="lead text-secondary">Effective Date: {effectiveDate}</p>
            </div>

            <Card className="p-4 shadow-lg border-0 rounded-4">
                <p>
                    Welcome to <a href={siteUrl}>{siteName}</a> (“we”, “our”, “us”). This Privacy Policy explains how we
                    collect, use, disclose, and safeguard your information when you visit our website or use our services.
                    By using our website, you agree to this Privacy Policy.
                </p>

                <section>
                    <h3>1. Information We Collect</h3>
                    <ul>
                        <li>
                            <strong>Personal Information:</strong> Name, email, phone number, and other contact details provided
                            during form submission or booking.
                        </li>
                        <li>
                            <strong>Booking Information:</strong> Travel preferences, destination choices, and payment details
                            (no full card info is stored).
                        </li>
                        <li>
                            <strong>Technical Data:</strong> IP address, browser type, operating system, and cookie data.
                        </li>
                    </ul>
                </section>

                <section>
                    <h3>2. How We Use Your Information</h3>
                    <ul>
                        <li>To process bookings, payments, and inquiries.</li>
                        <li>To send confirmations, updates, and travel reminders.</li>
                        <li>To enhance our website and customer experience.</li>
                        <li>To comply with legal and regulatory requirements.</li>
                    </ul>
                </section>

                <section>
                    <h3>3. Cookies and Tracking Technologies</h3>
                    <p>
                        Our website uses cookies to enhance user experience and analyze traffic. You can control cookies through
                        your browser settings. Disabling cookies may limit certain features.
                    </p>
                </section>

                <section>
                    <h3>4. Google AdSense and Analytics</h3>
                    <p>
                        We may use Google AdSense and Google Analytics to display ads and analyze performance. These tools use
                        cookies to collect non-personal data. You can opt out at{" "}
                        <a href="https://adssettings.google.com/" target="_blank" rel="noreferrer">
                            https://adssettings.google.com/
                        </a>
                        .
                    </p>
                </section>

                <section>
                    <h3>5. Sharing of Information</h3>
                    <p>
                        We may share limited data with trusted partners (payment gateways, hotels, or transport providers) to
                        complete your bookings. We never sell your personal data.
                    </p>
                </section>

                <section>
                    <h3>6. Data Security</h3>
                    <p>
                        We use secure protocols and safeguards to protect your data. However, no online system is 100% secure,
                        so we cannot guarantee absolute safety.
                    </p>
                </section>

                <section>
                    <h3>7. Third-Party Links</h3>
                    <p>
                        Our website may contain external links. We are not responsible for their privacy practices. Review
                        their policies before sharing personal info.
                    </p>
                </section>

                <section>
                    <h3>8. Children’s Privacy</h3>
                    <p>
                        Our services are not intended for individuals under 13. If your child has shared personal info, please
                        contact us for removal.
                    </p>
                </section>

                <section>
                    <h3>9. Your Data Rights</h3>
                    <p>
                        You can request to access, correct, or delete your data anytime by contacting us at{" "}
                        <a href={`mailto:${contactEmail}`}>{contactEmail}</a> or call {contactPhone}.
                    </p>
                </section>

                <section>
                    <h3>10. Updates to This Policy</h3>
                    <p>
                        We may revise this policy occasionally. Changes will appear on this page with an updated effective date.
                    </p>
                </section>

                <section>
                    <h3>11. Contact Us</h3>
                    <p>
                        For privacy-related inquiries:
                        <br />📧 <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                        <br />☎️ {contactPhone}
                    </p>
                </section>

                <p className="text-muted small text-center mt-4">
                    Last Updated: {effectiveDate}
                </p>
            </Card>
        </Container>
    );
}
